<template>
  <input
    type="submit"
    :value="schema.buttonText"
    @click="click"
    :disabled="disabled">
</template>

<script>
  import { abstractField } from 'vue-form-generator';
  import { mapMutations } from 'vuex';

  export default {
    mixins: [abstractField],

    methods: {
      ...mapMutations([
        'setSubmissionAttempted',
      ]),

      click() {
        if (this.schema.validateBeforeSubmit === true) {
          this.setSubmissionAttempted(true);
          if (!this.$parent.vfg.validate()) {
            this.setSubmissionAttempted(false);
            // There are validation errors. Stop the submit
            return;
          }
        }
        if (this.schema.onSubmit) {
          this.schema.onSubmit(this.model, this.schema, this.formOptions.context, this.$parent.vfg);
        }
      },
    },
  };
</script>
